import React from "react";

const OutbrainChannelIcon = ({
  color,
  className,
}: {
  color: string;
  className: string;
}) => {
  return (
    <svg
      version="1.1"
      viewBox="0 0 72.7 71.7"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          fill={color}
          fillRule="evenodd"
          clipRule="evenodd"
          d="M54.3,59.9c-2.1,2.1-4.7,3.8-7.5,5c-2.9,1.2-6,1.8-9.4,1.8c-3.4,0-6.5-0.6-9.4-1.8c-2.9-1.2-5.4-2.8-7.6-5
          c-2.1-2.1-3.8-4.6-5-7.5c-1.2-2.8-1.8-5.8-1.8-9h5.7c0.1,1,0.3,1.9,0.6,2.8c0.4,1,1.1,1.9,1.8,2.7c0.8,0.8,1.7,1.4,2.7,1.8
          c1,0.4,2.2,0.7,3.4,0.7c1.2,0,2.4-0.2,3.4-0.7c1-0.4,2-1,2.7-1.8c0.8-0.8,1.4-1.7,1.8-2.7c0.3-0.7,0.5-1.4,0.6-2.2h1.8
          c0.1,0.8,0.3,1.5,0.6,2.2c0.4,1,1.1,1.9,1.8,2.7c0.8,0.8,1.7,1.4,2.7,1.8c1,0.4,2.2,0.7,3.4,0.7c1.2,0,2.4-0.2,3.4-0.7
          c1-0.4,2-1,2.7-1.8c0.8-0.8,1.4-1.7,1.8-2.7c0.4-0.9,0.6-1.8,0.6-2.8h5.7c0,3.2-0.6,6.2-1.8,9C58.1,55.3,56.5,57.8,54.3,59.9
          M33,42.9c0,0.7-0.1,1.4-0.4,2c-0.3,0.6-0.6,1.1-1.1,1.6c-0.5,0.5-1,0.8-1.6,1.1c-0.6,0.3-1.3,0.4-2,0.4c-0.7,0-1.4-0.1-2-0.4
          c-0.6-0.3-1.2-0.6-1.6-1.1c-0.5-0.5-0.8-1-1.1-1.6c-0.3-0.6-0.4-1.3-0.4-2c0-0.7,0.1-1.4,0.4-2c0.3-0.6,0.6-1.1,1.1-1.6
          c0.5-0.5,1-0.8,1.6-1.1c0.6-0.3,1.3-0.4,2-0.4c0.7,0,1.4,0.1,2,0.4c0.6,0.3,1.2,0.6,1.6,1.1c0.5,0.5,0.8,1,1.1,1.6
          C32.9,41.5,33,42.2,33,42.9 M52,42.9c0,0.7-0.1,1.4-0.4,2c-0.3,0.6-0.6,1.1-1.1,1.6c-0.5,0.5-1,0.8-1.6,1.1
          c-0.6,0.3-1.3,0.4-2,0.4c-0.7,0-1.4-0.1-2-0.4c-0.6-0.3-1.2-0.6-1.6-1.1c-0.5-0.5-0.8-1-1.1-1.6c-0.3-0.6-0.4-1.3-0.4-2
          c0-0.7,0.1-1.4,0.4-2c0.3-0.6,0.6-1.1,1.1-1.6c0.5-0.5,1-0.8,1.6-1.1c0.6-0.3,1.3-0.4,2-0.4c0.7,0,1.4,0.1,2,0.4
          c0.6,0.3,1.2,0.6,1.6,1.1c0.5,0.5,0.8,1,1.1,1.6C51.8,41.5,52,42.2,52,42.9 M15.7,33.2c4.1-1.3,9.4-3,9.4-3
          C36.9,26.4,38.5,22,38.5,22s2.5,4.4,11.1,7.4c0,0,4.7,1.6,9.2,3.2c0.2,0.4,0.5,0.9,0.6,1.3c0.8,1.8,1.3,3.8,1.6,5.8h-6.1l0-0.1
          c-0.4-1-1.1-1.9-1.8-2.7c-0.8-0.8-1.7-1.4-2.7-1.8c-1-0.4-2.2-0.6-3.4-0.6c-1.2,0-2.4,0.2-3.4,0.6c-1,0.4-2,1-2.7,1.8
          c-0.8,0.8-1.4,1.7-1.8,2.7c-0.1,0.3-0.3,0.7-0.4,1h-2.3c-0.1-0.3-0.2-0.7-0.4-1c-0.4-1-1.1-1.9-1.8-2.7
          c-0.8-0.8-1.7-1.4-2.7-1.8c-1.1-0.4-2.2-0.6-3.4-0.6c-1.2,0-2.4,0.2-3.4,0.6c-1,0.4-2,1-2.7,1.8c-0.8,0.8-1.4,1.7-1.8,2.7
          c0,0,0,0.1,0,0.1h-6.1c0.3-2,0.8-3.9,1.6-5.8C15.5,33.6,15.6,33.4,15.7,33.2 M70.9,21.7c-1.9-4.4-4.4-8.2-7.7-11.4
          C60,7.1,56.1,4.6,51.7,2.7C47.3,0.9,42.5,0,37.4,0S27.4,0.9,23,2.7c-4.4,1.8-8.2,4.3-11.5,7.6c-3.3,3.2-5.8,7-7.7,11.4
          C1.9,26,1,30.8,1,35.9c0,5.1,0.9,9.8,2.8,14.2c1.9,4.4,4.4,8.2,7.7,11.4c3.3,3.2,7.1,5.7,11.5,7.6c4.4,1.8,9.2,2.7,14.4,2.7
          s9.9-0.9,14.4-2.7c4.4-1.8,8.2-4.3,11.5-7.6c3.3-3.2,5.8-7,7.7-11.4c1.8-4.4,2.8-9.1,2.8-14.2C73.7,30.8,72.8,26,70.9,21.7"
        />
      </g>
    </svg>
  );
};

export default OutbrainChannelIcon;
